import { cloneDeep } from "lodash";

const defaultState = {
  subscribed: null,
  notificationsEnabled: true,
  engBaseTopic: null,
  engSubTopic: null,
  engTopic: null,
  onlineLearners: []
};

export default {
  namespaced: true,
  state: cloneDeep(defaultState),
  getters: {
    getNumberofOnlineLearners: state => {
      return state.onlineLearners.length;
    },
    getNotificationsEnabled: state => {
      return state.notificationsEnabled;
    },
    getOnlineLearners: state => {
      return state.onlineLearners;
    },
    getEngSubscribed: state => {
      return state.subscribed;
    }
  },
  mutations: {
    resetState(state) {
      const s = cloneDeep(defaultState);
      Object.keys(s).forEach(key => {
        state[key] = s[key];
      });
    },
    updateNotificationsEnabled(state) {
      state.notificationsEnabled = !state.notificationsEnabled;
    },
    updateSubscribed(state, val) {
      state.subscribed = val;
    },
    addLearnerToOnlineList(state, learnerId) {
      state.onlineLearners.push(learnerId);
    },
    removeLearnerInOnlineList(state, learnerId) {
      const index = state.onlineLearners.findIndex(
        userId => userId == learnerId
      );
      if (index !== -1) {
        state.onlineLearners.splice(index, 1);
      }
    },
    setEngSubTopic(state) {
      state.engSubTopic = `${state.engBaseTopic}/#`;
    },
    setEngTopic(state, extension) {
      state.engTopic = `${state.engBaseTopic}/${extension}`;
    },
    setEngBaseTopic(state) {
      state.engBaseTopic = `${process.env.VUE_APP_TOPIC_ENV}/eng/active`;
    }
  },
  actions: {}
};
